module.exports = __webpack_public_path__ + "media/images/about/ac_6-44d12b660b30531c4385e9c5d7728e8a.jpg";